"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTransactionSerialization = void 0;
class PaymentTransactionSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.payment_presented_timestamp = entity.payment_presented_timestamp
            ? entity.payment_presented_timestamp.getTime() * 1000000
            : undefined;
        copy.expiry_time = entity.expiry_time
            ? entity.expiry_time.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.payment_presented_timestamp = entity.payment_presented_timestamp
            ? new Date(entity.payment_presented_timestamp / 1000000)
            : undefined;
        copy.expiry_time = entity.expiry_time
            ? new Date(entity.expiry_time / 1000000)
            : undefined;
        return copy;
    }
}
exports.PaymentTransactionSerialization = PaymentTransactionSerialization;
